import React from "react";

const TermsAndConditions = ({ darkTheme }) => {
  return (
    <div
      id="terms-policy"
      className="modal fade"
      role="dialog"
      aria-hidden="true"
    >
      <div
        className="modal-dialog modal-lg modal-dialog-centered"
        role="document"
      >
        <div
          className={
            "modal-content " + (darkTheme ? "bg-dark-2 text-light" : "")
          }
        >
          <div className="modal-header">
            <h5 className={"modal-title " + (darkTheme ? "text-white" : "")}>
              Terms &amp; Policy
            </h5>
            <button
              type="button"
              className={"btn-close " + (darkTheme ? "btn-close-white" : "")}
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body p-4">
            <h3 className={"mb-3 mt-4 " + (darkTheme ? "text-white" : "")}>
              Terms of Use
            </h3>
            <p>
              Welcome to Ka Ya Kwan's Resume Website. These Terms of Use govern
              your access to and use of this website. By accessing or using the
              website, you agree to be bound by these Terms.
            </p>
            <h5 className={"text-4 mt-4 " + (darkTheme ? "text-white" : "")}>
              Part I – Website Usage
            </h5>
            <p>
              This website is intended to provide information about Ming Chun
              Hon's professional skills and experience. Any misuse or
              unauthorized access is strictly prohibited.
            </p>
            <h5 className={"text-4 mt-4 " + (darkTheme ? "text-white" : "")}>
              Part II – Intellectual Property Rights
            </h5>
            <p>
              All content on this website, including text, graphics, logos, and
              images, is the property of Ka Ya Kwan and is protected by
              copyright and other intellectual property laws.
            </p>
            <h5 className={"text-4 mt-4 " + (darkTheme ? "text-white" : "")}>
              Part III – Limitation of Liability
            </h5>
            <p>
              Ka Ya Kwan will not be liable for any damages resulting from the
              use of this website. The website is provided "as is" without any
              warranties.
            </p>
            <h3 className={"mb-3 mt-4 " + (darkTheme ? "text-white" : "")}>
              Privacy Policy
            </h3>
            <p>
              Your privacy is important to us. This Privacy Policy explains how
              we collect, use, and protect your personal information.
            </p>
            <ol className="lh-lg">
              <li>
                We collect minimal personal information, such as name and email,
                only when voluntarily provided by you for specific purposes like
                inquiries or newsletter subscriptions.
              </li>
              <li>
                We are committed to ensuring the security of your personal
                information and will not share it with third parties without
                your explicit consent.
              </li>
              <li>
                This website may use cookies to enhance user experience, which
                can be managed through your browser settings.
              </li>
              <li>
                We may update this Privacy Policy periodically. We encourage you
                to review it regularly.
              </li>
              <li>
                For any questions or concerns regarding these terms or your
                personal data, please contact us directly.
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
